

const WordofWisdomeCard = () => {
    return (

        <>

            {/* <!--Sidebar Page Container--> */}
            <div className="sidebar-page-container">
                <div className="auto-container">
                    <div className="row clearfix">

                        {/* <!--Content Side / Blog Detail--> */}
                        <div className="content-side col-lg-12 col-md-12 col-sm-12">
                            <div className="post-details">
                                {/* <!--Blog Details--> */}
                                <div className="blog-details">


                                    <div className="lower-box">


                                        <div className="panel panel-primary">
                                            <div className="panel panel-heading">
                                                <h4>Words of Wisdom - Question & Answer Session - #137 </h4>
                                            </div>

                                            <div className="panel panel-body">
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                        {/* <!--<p> <img src="images/wordofwisdom.jpg" /></p>--> */}

                                                        <p> Dear readers, it is my utmost pleasure to present a series of Q&amp;A
                                                            sessions between Shri Maharaj Ji and devotees. </p>
                                                        <p> <strong> Devotee:</strong>  Maharaj Ji, am I seeing faults in others when I point out mistakes in someone’s work at my place of employment?</p>
                                                        <p>
                                                            <strong> Maharaj Ji:</strong> Not at all. It would be a mistake if you had affection or aversion towards the person.
                                                             If you love someone, you will overlook all their mistakes. If you hate someone, you will falsely accuse him of wrongdoing. 
                                                             In both these situations you will be making a mistake.

                                                           
                                                           
                                                      </p>

                                                       <p> <strong> Devotee:</strong>  Maharaj Ji, which are the different classes of love? </p> 

                                            
 
                                                         <p> <strong> Maharaj Ji:</strong>  Number one is Sadharani Rati – loving your Beloved for your own happiness. This is the lowest class of love. Number two is Samanjasa Rati – loving your Beloved for His happiness as well as yours. Number three is Samartha Rati – loving your Beloved only for His happiness. This is completely selfless love, which is the highest form of love.
                                                         
                                                       </p>


                                                        <p> <strong> Devotee:</strong> Maharaj Ji, kindly give examples of devotees belonging to these three classes of love. </p> 
                                                        <p> <strong> Maharaj Ji:</strong>Kubja is an example of a devotee whose love for Shri Krishna is Sadharani Rati. She desires Him to remain with her as her Beloved, and He fulfills her pure desire. Gajraj is another example. 
                                                        He was a pure devotee who called out to God to save his life. 16,108 queens of Shri Krishna in Dvarika are examples of Samanjasa Rati devotees. They desire His happiness but also look out for their own.
                                                        <br/>
                                                        The Gopis (milkmaidens of Braj) who are completely selfless are examples of Samartha Rati devotees. These devotees have no concern for their own happiness for they are only concerned with the happiness of their Beloved.</p>
                                                        <p>
                                                        <p><strong> Devotee:</strong> Maharaj Ji, is it enough for us to attain freedom from Maya?</p>
                                                        </p>
                                                        <p><strong> Maharaj Ji:</strong> No, because freedom from Maya will be given even if you attain liberation. Your aim is to selflessly love Shri Krishna as your Beloved and attain divine love. You will then serve your Beloved. The divine and selfless love will be given to you by the Guru. With that love you will have the privilege of serving Shri Krishna.
                                                             Therefore, liberation from Maya is not your aim. Your aim is to attain divine love and serve Shri Krishna.</p>





                                                          

                                                           


                                                       

                                                        
                                                     

                                                        <hr />
                                                        <p> Yours,</p>
                                                        <p> Didi Ji</p>
                                                        <p className="text-center"> Note: You may direct your spiritual questions to me
                                                            directly at</p>
                                                        <p className="text-center"> s_didi@radhamadhavsociety.org</p>


                                                    </div>

                                                </div>

                                            </div>


                                        </div>




                                    </div>






                                </div>





                            </div>

                        </div>


                    </div>
                </div>
            </div>
            {/* <!-- End Sidebar Page Container --> */}



        </>


    )

}

export default WordofWisdomeCard;